import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { CamTool } from '../../models/cam-tool';
import { CamToolBuilder } from '../../models/builders/cam-tool.builder';

const camToolBody = (camTool: CamTool) => ({
  hash: camTool.hash,
  name: camTool.name,
  tool: camTool.tool
});

@Injectable()
export class CamToolApiService {

  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }cam-tools`;
  }

  createCamTool(camTool) {
    return this.httpClient.post(this.apiUrl, camToolBody(camTool)).pipe(map(CamToolBuilder.fromJson));
  }

  deleteCamTool(camTool: CamTool) {
    return this.httpClient.delete(`${ this.apiUrl }/${ camTool.hash }`);
  }

  getCamTools() {
    return this.httpClient.get(`${ this.apiUrl }/`).pipe(map(CamToolBuilder.fromList));
  }

  getCamTool(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`).pipe(map(CamToolBuilder.fromJson));
  }

  updateCamTool(camTool: CamTool) {
    const body = camToolBody(camTool);
    return this.httpClient.put(`${ this.apiUrl }/${ camTool.hash }`, body);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/cam-tool-api.service.ts